// src/pages/Gallery.js

import React, { useState } from "react";
import "./gallery.css";

const Gallery = () => {
  const totalImages = 31;        // गरजेनुसार 25 करा
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openLightbox = (index) => setSelectedIndex(index);
  const closeLightbox = () => setSelectedIndex(null);

  const goPrev = () => {
    setSelectedIndex((prev) => (prev <= 0 ? totalImages - 1 : prev - 1));
  };

  const goNext = () => {
    setSelectedIndex((prev) => (prev >= totalImages - 1 ? 0 : prev + 1));
  };

  return (
    <>
      <div className="gallery-container">
        <h2 className="gallery-title">
          गावाचा विकास – छायाचित्रांतून
        </h2>

        <div className="gallery-grid">
          {[...Array(totalImages)].map((_, i) => (
            <div
              className="gallery-card"
              key={i}
              onClick={() => openLightbox(i)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && openLightbox(i)}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/photo${i + 1}.jpg`}
                alt={`विकास काम ${i + 1}`}   // warning गेली! "photo", "image" शब्द नाही
                className="gallery-img"
                loading="lazy"
              />
              <div className="overlay">
                <span>मोठे पहा</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ================ सुंदर Lightbox (Popup) ================ */}
      {selectedIndex !== null && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="close-btn" onClick={closeLightbox}>×</button>
          <button className="nav-btn prev" onClick={(e) => { e.stopPropagation(); goPrev(); }}>‹</button>
          <button className="nav-btn next" onClick={(e) => { e.stopPropagation(); goNext(); }}>›</button>

          <div className="lightbox-image-container">
            <img
              src={`${process.env.PUBLIC_URL}/images/photo${selectedIndex + 1}.jpg`}
              alt={`विकास काम ${selectedIndex + 1}`}
              className="lightbox-image"
            />
            <div className="lightbox-counter">
              {selectedIndex + 1} / {totalImages}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;